<template>
<w-settings-content-template>
  <el-tabs slot="content" type="card" v-model="activeTab">
    <el-tab-pane label="이벤트 예측" name="WEventPredictView">
      <w-event-predict-view ref="WEventPredictView"/>
    </el-tab-pane>
    <el-tab-pane label="임계치 가이드" name="WEventPredictGuideView">
      <w-event-predict-guide-view ref="WEventPredictGuideView"/>
    </el-tab-pane>
  </el-tabs>
</w-settings-content-template>
</template>

<script>
import WSettingsContentTemplate from '@/components/template/SettingsContentTemplate';
import WEventPredictView from './EventPredictView';
import WEventPredictGuideView from './EventPredictGuideView';

/**
 * 이벤트 예측 설정 화면
 */
export default {
  name: 'WEventPredictSetting',
  components: {
    WSettingsContentTemplate,
    WEventPredictView,
    WEventPredictGuideView,
  },
  props: {
    title: String,
  },
  watch: {
    activeTab: {
      immediate: true,
      handler(value) {
        this.$nextTick(() => {
          // this.$refs[value].initTab();
          this.$refs[value].loadData();
        });
      },
    },
  },
  data() {
    return {
      activeTab: 'WEventPredictView',
    };
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/operation/BasicInfoSettings/EventPredictSetting/index.vue